import React from "react";
import { injectIntl } from "react-intl";
import withStyles from "@material-ui/core/styles/withStyles";
import classNames from "classnames";
// core components
import Icon from '@material-ui/core/Icon';
import GridContainer from "@app/components/Grid/GridContainer";
import GridItem from "@app/components/Grid/GridItem";
// styles
import bannerStyle from "@app/assets/jss/material-kit-pro-react/views/landingPageSections/bannerStyle";

import lineChart from "@app/assets/img/icons/line-chart.svg";
const StatsBanner = props => {
    const { classes } = props;
    const intro = props.intl.formatMessage({ id: "stats.banner.headline.intro" });
    const outro = props.intl.formatMessage({ id: "stats.banner.headline.outro" });
    const reference = props.intl.formatMessage({ id: "stats.banner.reference.text" });
    const sourceLink = props.intl.formatMessage({ id: "stats.banner.reference.link" });
    return (
        <div
            className={classNames(
                classes.socialLine,
                classes.textCenter,
                classes.dark,
                classes.bigIcons
            )}
        >
        <div className={classes.container}>
            <GridContainer justify="center">
                <GridItem xs={12} sm={8} md={10}>
                    <h2 className={classes.title}>
                        {intro}, <u>{outro}</u>
                    </h2>
                    <p className={classes.description}><sub><a href={sourceLink} target="_blank" rel="noopener">{reference}</a></sub></p>
                </GridItem>
                <GridItem xs={12} sm={4} md={2}>
                    <Icon className={classes.iconRoot}>
                        <img className={classes.imageIcon} src={lineChart}/>
                    </Icon>
                </GridItem>
            </GridContainer>
        </div>
      </div>
    );
}

export default injectIntl(withStyles(bannerStyle)(StatsBanner));